import React, { Fragment, useEffect, useState } from "react";
import { Typography, Paper } from "@mui/material";
import ProductionOverviewDataGrid from "./ProductionOverviewDataGrid";
import classes from "./ProductionOverview.module.css";
import { useSelector } from "react-redux";

const ProductionOverview = (props) => {
  const { year } = props;
  let results = [];

  let ma_top = "",
    ma_total = 0,
    ms_top = "",
    ms_total = 0,
    productMA = "Medicare Advantage",
    productMS = "Medicare Supplement";

  const dataSummaryForAgency = useSelector(
    (state) => state.productionStatisticsForAgencyFull.dataSummary
  );

  const data = dataSummaryForAgency;

  // const isLoading = useSelector(
  //   (state) => state.productionStatisticsForAgencyFull.isLoading
  // );

  const [maAgentName, setMaAgentName] = useState("");
  const [medSuppAgentName, setMedSuppAgentName] = useState("");

  const filteredData = data.filter((row) => row.salesYear === year);

  useEffect(() => {
    let agents = [];
    let ma = [];
    let medSupp = [];

    const topMAAgent = () => {
      if (ma.length > 0) {
        const maxTotal = ma.reduce(
          (max, item) => (item.total > max.total ? item : max),
          ma[0]
        );
        return maxTotal.name;
      }
    };

    const topMedsuppAgent = () => {
      if (medSupp.length > 0) {
        const maxTotal = medSupp.reduce(
          (max, item) => (item.total > max.total ? item : max),
          medSupp[0]
        );
        return maxTotal.name;
      }
    };

    const filteredByAgent = () => {
      filteredData.forEach((item) => {
        agents.push(item.agentId);
      });
    };

    const distinctListOfAgentIds = (arr) => {
      return [...new Set(arr)];
    };

    const uniqueListOfIds = () => {
      filteredByAgent();
      const results = distinctListOfAgentIds(agents);
      return results;
    };

    const getNameAndTotalMA = (id) => {
      const data = filteredData.filter((row) => row.agentId === id);
      const name = data[0].agentName;
      let total = 0;
      data.forEach((item) => {
        total += item.maTotal;
      });
      return { name, total };
    };

    const getNameAndTotalMedSupp = (id) => {
      const data = filteredData.filter((row) => row.agentId === id);
      const name = data[0].agentName;
      let total = 0;
      data.forEach((item) => {
        total += item.medsuppTotal;
      });
      return { name, total };
    };

    const processData = () => {
      const Ids = uniqueListOfIds();
      Ids.forEach((id) => {
        ma.push(getNameAndTotalMA(id));
        medSupp.push(getNameAndTotalMedSupp(id));
      });
    };

    if (data && year) {
      processData();
      setMaAgentName(topMAAgent());
      setMedSuppAgentName(topMedsuppAgent());
    }
  }, [data, year, filteredData, setMaAgentName, setMedSuppAgentName]);

  if (data && year) {
    ma_top = maAgentName;
    ma_total = filteredData.reduce(
      (sum, row) => sum + parseInt(row.maTotal),
      0
    );
    ms_top = medSuppAgentName;
    ms_total = filteredData.reduce(
      (sum, row) => sum + parseInt(row.medsuppTotal),
      0
    );
  }

  results.push(
    {
      id: 1,
      product: productMA,
      top: ma_top,
      total: ma_total,
    },
    {
      id: 2,
      product: productMS,
      top: ms_top,
      total: ms_total,
    }
  );

  return (
    <Fragment>
      <Typography color="#003760" gutterBottom variant="h5" component="h3">
        Production Overview
      </Typography>
      <Paper className={classes.paper}>
        <ProductionOverviewDataGrid tableData={results} isLoading={false} />
      </Paper>
    </Fragment>
  );
};

export default ProductionOverview;
